/* import __COLOCATED_TEMPLATE__ from './settings.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import type HandoffToZendeskAgentStepType from 'embercom/models/operator/visual-builder/step/handoff-to-zendesk-agent';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

interface Args {
  isReadOnly: boolean;
  step: HandoffToZendeskAgentStepType;
}

export default class Settings extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;

  get isEndUserAuthEnabled(): boolean {
    return (
      this.finStandaloneService.zendeskConfig?.sunshineIntegration?.endUserAuthEnabled || false
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::HandoffToZendeskAgent::Settings': typeof Settings;
    'workflows/graph-editor/node-items/steps/handoff-to-zendesk-agent/settings': typeof Settings;
  }
}
